import React from "react";
import { checkFeature } from "../hooks/useFeatures";

const BuyingModeContext = React.createContext({
	isBuyingMode: false,
	setBuyingMode: value => { },
	isFeatureEnabled: () => {},
});

export const useBuyingMode = () => {
	const context = React.useContext(BuyingModeContext);
	if (!context) {
		throw new Error("useBuyingMode must be used within a BuyingModeProvider");
	}
	return context;
};

export const BuyingModeProvider = ({ children }) => {
	const [isBuyingMode, setIsBuyingMode] = React.useState(() => {
		const stored = sessionStorage.getItem("buying_mode");
		return stored === "true";
	});

	const setBuyingMode = React.useCallback((value) => {
		setIsBuyingMode(value);
		sessionStorage.setItem("buying_mode", value.toString());
	}, []);

	const isFeatureEnabled = () => {
		return checkFeature("catalog.modes.buying");
	};

	const value = React.useMemo(() => ({
		isBuyingMode,
		setBuyingMode,
		isFeatureEnabled,
	}), [isBuyingMode, setBuyingMode]);

	return (
		<BuyingModeContext.Provider value={value}>
			{children}
		</BuyingModeContext.Provider>
	);
};

export default BuyingModeContext;
